import { isHR, isHRAdmin } from '@/old/utils/helper';

import { ReportSettings, ReportSettingsPrivacyType } from '../models';

export const canManageReportSettings = ({ privacyType }: ReportSettings): boolean =>
    privacyType === ReportSettingsPrivacyType.PERSONAL || isHRAdmin() || isHR();
